module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step2_Image10.290357a5.jpg";